import React from "react";
import Facet from "./Facet";
import CategoryFacet from "./CategoryFacet";
import toggleFacet from "./toggle-facet";
import Icon from "Shared/Icon";
import classnames from "classnames";
import { translate } from "Shared/translate";
import * as styles from "./base.scss";
import shallowEquals from "Shared/shallow-equals";
import ConceptFacet, { conceptFilterParameterName } from "./ConceptFacet";
import { getQueryStringParameterByName } from "./../../MyMenigo/Blocks/DeliveryBlock/Components/action-creators";
// const DEFAULT_OPEN_FACET_COUNT = 6;
const freeTexthDebounceMs = 500;
export default class FacetList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentFreeText: "",
            currentFreeTextFilter: null,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.currentFreeTextValue !== nextProps.currentFreeTextValue) {
            this.setState({
                currentFreeText: nextProps.currentFreeTextValue,
            });
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        const shouldUpdate = nextProps.facets !== this.props.facets ||
            !shallowEquals(nextState, this.state, true) || !shallowEquals(nextProps, this.props, true);
        nextProps.subCategories !== this.props.subCategories;
        if (!shouldUpdate) {
            console.info("Ignoring update to FacetList");
        }
        return shouldUpdate;
    }
    onFacetValueChange(fieldName, facetValue, selected, element) {
        if (fieldName == conceptFilterParameterName)
            !!this.props.facets.find((x) => x.fieldName == conceptFilterParameterName) &&
                this.props.facets
                    .find((x) => x.fieldName == conceptFilterParameterName)
                    .facetValues.filter((x) => x.text != facetValue.text)
                    .forEach((x) => (x.selected = false));
        const facets = toggleFacet(this.props.facets, fieldName, facetValue, selected);
        if (facets !== this.props.facets) {
            this.props.onFacetValueChange(facets, selected ? facetValue.ticket : null, element, this.state.currentFreeText);
        }
    }
    clearSearchTimeouts() {
        clearTimeout(this.currentSearchTimeout);
    }
    FreeTextSearch(textSearch) {
        this.clearSearchTimeouts();
        this.setState({
            currentFreeText: textSearch,
        });
        this.currentSearchTimeout = setTimeout(() => {
            this.props.onFreeTextValueChange(textSearch);
        }, freeTexthDebounceMs);
    }
    render() {
        const freeTextIsEmpty = this.state.currentFreeText === "";
        return (React.createElement("div", null,
            !this.props.hideFreeText && (React.createElement("div", { className: styles.freeTextSearchWrap },
                React.createElement("div", { className: styles.freeTextSearch },
                    React.createElement("div", { className: classnames(styles.searchWrapper, !freeTextIsEmpty ? styles.closeFreeTextSearch : ""), onClick: () => !freeTextIsEmpty && this.FreeTextSearch("") }, freeTextIsEmpty ? (React.createElement(Icon, { name: "search" })) : (React.createElement(Icon, { name: "close" }))),
                    React.createElement("input", { type: "text", placeholder: translate("/Shared/FreeTextSearch"), value: this.state.currentFreeText, onChange: (e) => this.FreeTextSearch(e.target.value) })))),
            !!this.props.conceptFacets &&
                React.createElement("ul", { className: styles.conceptfilters }, this.props.conceptFacets.map(facet => React.createElement(ConceptFacet, { facet: facet, openDefault: !!getQueryStringParameterByName(conceptFilterParameterName), onFacetValueChange: (facetValue, selected, element) => this.onFacetValueChange(facet.fieldName, facetValue, selected, element), setAndOrFilter: this.props.setAndOrFilter, key: facet.fieldName + '-' + facet.displayName, excludeCnt: this.props.excludeCnt }))),
            this.props.facets.length > 0 && (React.createElement("ul", { className: styles.list },
                !!!this.props.hideCategories &&
                    !!!this.props.showCategoriesLast && (React.createElement(CategoryFacet, { subCategories: this.props.subCategories, excludeCnt: this.props.excludeCnt })),
                this.props.facets.filter(x => x.fieldName != conceptFilterParameterName || !!!this.props.conceptFacets).map(facet => (React.createElement(Facet, { facet: facet, openDefault: facet.fieldName === "department" || this.props.defaultOpen, onFacetValueChange: (facetValue, selected, element) => this.onFacetValueChange(facet.fieldName, facetValue, selected, element), setAndOrFilter: this.props.setAndOrFilter, key: facet.fieldName, excludeCnt: this.props.excludeCnt }))),
                !!!this.props.hideCategories &&
                    !!this.props.showCategoriesLast && (React.createElement(CategoryFacet, { subCategories: this.props.subCategories, excludeCnt: this.props.excludeCnt }))))));
    }
}
